<script setup lang="ts">
import { onMounted, ref, useTemplateRef } from 'vue';
import { AlertCircleIcon, CircleCheck } from 'lucide-vue-next';
import { Alert, AlertTitle } from '@/components/ui/alert';

const props = defineProps<{
    position: 'top-form' | 'bottom-form';
}>();

const container = useTemplateRef('container');
const successMessage = ref<string>();
const errorMessage = ref<string>();

type FormieMessageEvent = CustomEventInit<{
    message: string;
    position: 'top-form' | 'bottom-form';
}>;

onMounted(() => {
    if (!container.value) return;

    container.value.addEventListener(
        'formie:show-success-message',
        (e: FormieMessageEvent) => {
            if (!e.detail) return;

            const { message, position } = e.detail;

            if (position === props.position) {
                successMessage.value = message;
            }

            errorMessage.value = undefined;
        }
    );

    container.value.addEventListener(
        'formie:show-error-message',
        (e: FormieMessageEvent) => {
            if (!e.detail) return;

            const { message, position } = e.detail;

            if (position === props.position) {
                errorMessage.value = message;
            }

            successMessage.value = undefined;
        }
    );

    container.value.addEventListener('formie:reset-messages', () => {
        errorMessage.value = undefined;
        successMessage.value = undefined;
    });
});
</script>

<template>
    <div
        ref="container"
        data-slot="form-messages"
        class="contents"
    >
        <Alert
            variant="success"
            v-if="successMessage"
        >
            <CircleCheck />
            <AlertTitle v-html="successMessage" />
        </Alert>
        <Alert
            variant="destructive"
            v-if="errorMessage"
        >
            <AlertCircleIcon />
            <AlertTitle v-html="errorMessage" />
        </Alert>
    </div>
</template>
